import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import frTranslations from "./locales/fr.json";
import deTranslations from "./locales/de.json";

i18n.use(initReactI18next).init({
  fallbackLng: "de",
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    fr: {
      translation: frTranslations,
    },
    de: {
      translation: deTranslations,
    },
  },
});

export default i18n;
